import React from "react";
import { useParams, Link } from "react-router-dom";
import sponsors from "./catalog/sponsors";
import { FaFacebookF, FaInstagram, FaGlobe, FaYoutube, FaWhatsapp, FaTiktok, FaVoicemail, FaAddressBook, FaAddressCard } from "react-icons/fa";
import "./EventPage.css";

const iconStyles = {
  marginRight: 8,
  verticalAlign: "middle",
};

const buttonStyles = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "8px",
  padding: "12px 0",
  margin: "0 0 12px 0",
  border: "none",
  borderRadius: "4px",
  background: "#ff5500",
  color: "#fff",
  fontWeight: "bold",
  textDecoration: "none",
  cursor: "pointer",
  fontSize: "1rem",
  transition: "background 0.2s, transform 0.18s, box-shadow 0.18s, filter 0.18s",
  width: "100%",
  textAlign: "center",
};

const mobileOuter = {
  minHeight: "100vh",
  background: "linear-gradient(135deg, #e0e0e0 0%, #bdbdbd 100%)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const mobileFrame = {
  maxWidth: 375,
  width: "100%",
  minHeight: 700,
  background: "#222",
  borderRadius: "40px",
  boxShadow: "0 8px 32px rgba(0,0,0,0.25)",
  border: "6px solid #333",
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  position: "relative",
};

const notch = {
  width: 120,
  height: 20,
  background: "#111",
  borderRadius: "0 0 16px 16px",
  position: "absolute",
  top: 0,
  left: "50%",
  transform: "translateX(-50%)",
  zIndex: 2,
};

const SponsorDetail = () => {
  const { slug } = useParams();
  const sponsor = sponsors.find(s => s.slug === slug);

  if (!sponsor) {
    return (
      <div style={mobileOuter}>
        <div style={mobileFrame}>
          <div style={notch}></div>
          <section className="athlete-section" style={{ flex: 1 }}>
            <div className="hero-content">
              <h2>Auspiciante no encontrado</h2>
              <Link to="/" className="cta-button">Volver</Link>
            </div>
          </section>
        </div>
      </div>
    );
  }

  return (
    <div style={mobileOuter}>
      <div style={mobileFrame}>
        <div style={notch}></div>
        <section className="athlete-section" style={{ flex: 1, background: "#333", paddingTop: 32 }}>
          <div className="athlete-info" style={{ alignItems: "flex-start", flexDirection: "column" }}>
            <img
              src={sponsor.logo}
              alt={sponsor.name}
              className="athlete-photo"
              style={{ maxWidth: 160, margin: "0 auto 16px auto", borderRadius: 16, background: "#fff", padding: 8 }}
            />
            <div style={{ width: "100%", color: "#fff" }}>
              <h2 style={{ fontSize: "1.1rem", marginBottom: 8, color: "#fff" }}>{sponsor.name}</h2>
              <p
                className="sponsor-description"
                style={{ fontSize: "1rem", color: "#e0e0e0", textAlign: "left" }}
              >
                {sponsor.description.split('\n').map((line, i) => (
                  <React.Fragment key={i}>
                    {line}
                    <br />
                  </React.Fragment>
                ))}
              </p>
              <div style={{ margin: "16px 0", display: "flex", flexDirection: "column", gap: 8 }}>
                {sponsor.facebook && (
                  <a
                    href={sponsor.facebook}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ ...buttonStyles, background: "#1877f2" }}
                    className="cta-button"
                  >
                    <FaFacebookF style={iconStyles} />
                    Facebook
                  </a>
                )}
                {sponsor.instagram && (
                  <a
                    href={sponsor.instagram}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ ...buttonStyles, background: "#e1306c" }}
                    className="cta-button"
                  >
                    <FaInstagram style={iconStyles} />
                    Instagram
                  </a>
                )}
                {sponsor.tiktok && (
                  <a
                    href={sponsor.tiktok}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ ...buttonStyles, background: "#010101" }} // color oficial TikTok
                    className="cta-button"
                  >
                    <FaTiktok style={iconStyles} />
                    Tik Tok
                  </a>
                )}
                {sponsor.whatsapp && (
                  <a
                    href={sponsor.whatsapp}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ ...buttonStyles, background: "#25D366" }}
                    className="cta-button"
                  >
                    <FaWhatsapp style={iconStyles} />
                    Whatsapp
                  </a>
                )}
                {sponsor.youtube && (
                  <a
                    href={sponsor.youtube}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ ...buttonStyles, background: "#c4302b " }}
                    className="cta-button"
                  >
                    <FaYoutube style={iconStyles} />
                    Youtube
                  </a>
                )}
                {sponsor.website && (
                  <a
                    href={sponsor.website}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ ...buttonStyles, background: "#00b894" }}
                    className="cta-button"
                  >
                    <FaGlobe style={iconStyles} />
                    Sitio Web
                  </a>
                )}
                  {sponsor.email && (
                  <a
                    href={sponsor.email}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ ...buttonStyles, background: "#00b894" }}
                    className="cta-button"
                  >
                    <FaAddressCard style={iconStyles} />
                    Correo electrónico
                  </a>
                )}
              </div>
              <Link
                to="/"
                style={{
                  ...buttonStyles,
                  background: "#e0e0e0",
                  color: "#333",
                  fontWeight: "normal",
                  marginTop: 8,
                  border: "1px solid #ccc"
                }}
              >
                Yo apoyo a Freddy Azabache
              </Link>
            </div>
          </div>
        </section>
        <footer className="event-footer" style={{ background: "#111" }}>
          <a
            href="https://www.azabaches.net"
            target="_blank"
            rel="noopener noreferrer"
          >
            
          </a>
          <p style={{ fontSize: "0.8rem", color: "#fff", textAlign: "center", margin: 0, paddingBottom: 8 }}>
            &copy; 2025 Azabaches NET. Todos los derechos reservados.
          </p>
        </footer>
      </div>
    </div>
  );
};

export default SponsorDetail;